import {
  getEnglishEnvironment,
  getEnglishResource,
  translateCreature
} from '../data/ecologyTranslations';

const creatureGlyphs = {
  fish: '◁',
  salmon: '⋘',
  tuna: '◀',
  mackerel: '≋',
  school: '⋰',
  'flying-fish': '⌁',
  eel: '∿',
  squid: '♠',
  octopus: '✣',
  crab: '⌘',
  urchin: '✺',
  jellyfish: '♧',
  shell: '◒',
  angler: '◉',
  whale: '◜',
  spirit: '◇',
  cat: '猫'
};

function SceneFeatures({features, english}) {
  return (
    <div className="floor-ecology__scene">
      <div className="floor-ecology__section-title">
        <span>SCENE</span>
        <b>{english ? 'Floor Landmarks' : '樓層場景'}</b>
      </div>
      <div className="floor-ecology__scene-list">
        {features.map((feature, index) => (
          <div className="floor-ecology__scene-item" key={feature}>
            <i>{String(index + 1).padStart(2, '0')}</i>
            <span title={feature}>{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function CreatureItem({creature, index, english}) {
  const localized = translateCreature(creature);

  return (
    <article className="floor-ecology__creature">
      <i
        className={`floor-ecology__glyph floor-ecology__glyph--${creature.type}`}
        style={{'--delay': `${index * -0.7}s`}}
        aria-hidden="true"
      >
        {creatureGlyphs[creature.type] || '◁'}
      </i>
      <div className="floor-ecology__creature-copy">
        <strong>{english ? localized.name_en : creature.name}</strong>
        <small>
          {english ? localized.behavior_en : creature.behavior}
        </small>
      </div>
    </article>
  );
}

function SafeFloor({resources, english}) {
  const localizedResources = english
    ? resources.map(getEnglishResource)
    : resources;

  return (
    <div className="floor-ecology__safe">
      <div className="floor-ecology__safe-mark" aria-hidden="true">
        {english ? 'S' : '安'}
      </div>
      <div>
        <strong>
          {english
            ? 'No hostile creatures inhabit this floor'
            : '此層不會出現敵對生物'}
        </strong>
        <span>
          {english ? 'Recoverable: ' : '可採集：'}
          {localizedResources.join(' · ')}
        </span>
      </div>
    </div>
  );
}

export default function FloorEcologyContent({
  data,
  ecology,
  floor,
  lang
}) {
  const english = lang === 'en';
  const features = english
    ? getEnglishEnvironment(data)
    : ecology.environment;

  return (
    <>
      <header className="floor-ecology__header">
        <div className="floor-ecology__identity">
          <div>
            <span>FLOOR ECOLOGY</span>
            <strong>
              {english ? 'Scene & Ecology Record' : '場景與生態記錄'}
            </strong>
          </div>
        </div>
        <span className="floor-ecology__count">
          {ecology.safe
            ? english
              ? 'SAFE FLOOR · NO HOSTILES'
              : '安全層 · 無敵對生物'
            : english
              ? `${ecology.creatures.length} SPECIES`
              : `${ecology.creatures.length} 種生物`}
        </span>
      </header>

      <SceneFeatures features={features} english={english} />

      {ecology.safe ? (
        <SafeFloor resources={ecology.resources} english={english} />
      ) : (
        <div className="floor-ecology__creatures">
          {ecology.creatures.map((creature, index) => (
            <CreatureItem
              creature={creature}
              english={english}
              index={index}
              key={`${floor}-${creature.name}`}
            />
          ))}
        </div>
      )}
    </>
  );
}